import React, { FC } from "react";

import { BusinessInfoStep, BusinessInfoStepProps } from "components/Onboarding/components/V3/BusinessInfoStep";

import { OnboardingProps } from "../../models";

export const BusinessInfoStepContainer: FC<
    BusinessInfoStepProps & {
        initialProps: OnboardingProps;
        onNext(props: OnboardingProps): void;
        onBack?(): void;
    }
> = (props) => {
    return <BusinessInfoStep {...props} />;
};
